/**
 * @file consts for target app versions (semver) for compatibility check
 */
export const COMPATIBILITY__ATTACHMENT_PREVIEW = '1.7.0';
